module.exports = __webpack_public_path__ + "media/images/favicons/favicon-160x160-fdc6cc1471fbfeb1b611d5beac97adcc.png";